import { useState, useEffect, useContext } from 'react';
import { PersonContext } from '../context/PersonContext'; // ../../ → ../ 로 수정
import './backdoor.css'; // login.css 파일을 임포트합니다.

const BackLogin = () => {
  const [name, setName] = useState('');
  const [handphone, setHandphone] = useState('');
  const [passwd, setPasswd] = useState('');
  const [error, setError] = useState('');
  const { setPerson } = useContext(PersonContext); // PersonContext에서 setPerson을 가져옵니다.
  const host = process.env.REACT_APP_RESTAPI_URL;

  useEffect(() => {
    //if (error) alert(error);
  }, [error]);

  const handleLogin = async () => {
    const url = `${host}/oauth/backlogin`;
    console.log(`로그인 시도 : ${url}`);

    if (!name) {
      setError('성명을 입력해주세요.');
      return;
    }

    if (!handphone) {
      setError('핸드폰번호를 입력해주세요.');
      return;
    }

    const h = handphone.replace(/[^0-9]/g, ''); // 핸드폰번호에서 숫자만 남깁니다.
    if (h.length < 10 || h.length > 11) {
      setError('핸드폰번호는 10자리 또는 11자리 숫자로 입력해주세요.');
      return;
    }

    if (!passwd) {
      setError('비밀번호를 입력해주세요.');
      return;
    }

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name, handphone, passwd }),
      });

      console.log(`로그인 응답 : ${response.status} ${response.statusText}`);

      if (!response.ok) {
        throw new Error('로그인 실패');
      }

      const data = await response.json();
      console.log(`로그인 성공 : ${data}`);
      // 로그인 성공 시 받은 토큰을 sessionStorage에 저장합니다.
      sessionStorage.setItem('token', data);
      setError('');

      // sessionStorage에서 토큰을 가져옵니다.
      const token = sessionStorage.getItem('token');
      console.log(`토큰 : ${token}`); // 토큰을 콘솔에 표시합니다.
      if (!token) {
        throw new Error('토큰이 없습니다.');
      }

      // 토큰을 사용하여 사용자 정보를 가져옵니다.
      const personResponse = await fetch(`${host}/oauth/person`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!personResponse.ok) {
        throw new Error('사용자 정보 가져오기 실패');
      }

      console.log(personResponse);

      const personInfo = await personResponse.json();
      console.log('사용자 정보');
      console.log(personInfo);
      setPerson(personInfo); // 사용자 정보를 설정합니다.
      window.location.href = '/'; // 로그인 성공 후 홈으로 이동합니다.
    } catch (error) {
      console.error('로그인 오류:', error);
      setError(error.message);
    }
  };

  return (
    <div id="back_login">
      <div className="head">
        <h1>백도어 로그인</h1>
      </div>
      <div className="body">
        <ul className="form">
          <li>
            <label>성명</label>
            <span>
              <input
                type="text"
                placeholder="성명을 입력하세요."
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </span>
          </li>
          <li>
            <label>핸드폰번호</label>
            <span>
              <input
                type="text"
                placeholder="핸드폰번호를 숫자로만 입력하세요."
                value={handphone}
                onChange={(e) => setHandphone(e.target.value)}
                className='handphone'
              />
            </span>
          </li>
          <li>
            <label>비밀번호</label>
            <span>
              <input
                type="password"
                placeholder="비밀번호를 입력하세요."
                value={passwd}
                onChange={(e) => setPasswd(e.target.value)}
                className='passwd'
              />
            </span>
          </li>
        </ul>
        <button className="login" onClick={handleLogin}>로그인</button>
        {error && <div className="error">{error}</div>}
      </div>
    </div>
  );
};

export default BackLogin;
